// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icloud-ui-form-slider-with-number{align-items:center;display:flex;justify-content:flex-start}.icloud-ui-form-slider-with-number-range,.icloud-ui-form-slider-with-number-tailLabel{margin-left:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
